import moment from "moment";

export const historiqueSouscriptionTableColumns = [
  {
    field: "sequence",
    headerName: "Séquence",
    sortable: true,
    editable: false,
    valueGetter: ({ row }) => row.sequence ?? "-",
    flex: 1,
  },
  {
    field: "utilisateur",
    headerName: "Utilisateur",
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.user?.username ?? "-",
    flex: 3,
  },
  {
    field: "evenement",
    headerName: "Evènement",
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.evenement ?? "-",
    flex: 2,
  },
  {
    field: "etatSouscription",
    headerName: "Etat souscription",
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.etatDescription ?? "-",
    flex: 2,
  },
  {
    field: "informationEvenement",
    headerName: "Information évènement",
    sortable: false,
    editable: false,
    valueGetter: ({ row }) => row.informationEvenement ?? "-",
    flex: 3,
  },
  {
    field: "dateEvenement",
    headerName: "Date de l'évènement",
    sortable: true,
    editable: false,
    valueGetter: ({ row }) =>
      moment(new Date(row.dateCreation)).format("DD/MM/yyyy HH:mm ") ?? "-",
    flex: 2,
  },
];
